import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomerListView from "../CustomerListView/CustomerListView";
export default function CustomerHome() {
  const navigate = useNavigate();
  const [value, setValue] = useState("2");
  const map: any = {
    "1": "/partners/customers/dashboard",
    "2": "/partners/customers/list",
    "3": "/partners/customers/reports",
  };

  useEffect(() => {
    if (window.location.pathname == "/partners/customers/dashboard") {
      setValue("1");
    } else if (window.location.pathname == "/partners/customers/list") {
      setValue("2");
    } else if (window.location.pathname == "/partners/customers/reports") {
      setValue("3");
    }
  }, [window.location.pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    navigate(map[newValue]);
  };
  return (
    <div
      style={{
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: "#f5f7fa",
        height: "100vh",
      }}
    >
      <TabContext value={value}>
        <Box
          sx={{ borderBottom: 1, borderColor: "divider", width: "fit-content" }}
        >
          <TabList onChange={handleChange} className="pw-supplier-tabs">
            {/* <Tab
              value="1"
              sx={{ fontWeight: value == "1" ? "bold" : "regular" }}
              label="Dashboard"
            /> */}
            <Tab
              value="2"
              sx={{ fontWeight: value == "2" ? "bold" : "regular" }}
              label="List View"
            />
            {/* <Tab
              value="3"
              sx={{ fontWeight: value == "3" ? "bold" : "regular" }}
              label="Reports"
            /> */}
          </TabList>
        </Box>
        <TabPanel value="1">DashBoard Coming Soon</TabPanel>
        <TabPanel value="2">
          <CustomerListView />
        </TabPanel>
        <TabPanel value="3">Reports Coming Soon</TabPanel>
      </TabContext>
    </div>
  );
}
